// src/components/AccountSummaryStat.tsx
import React from 'react';

interface AccountSummaryItem {
    label: string;
    value: string | number;
}

const AccountSummaryStat: React.FC<{ data: AccountSummaryItem }> = ({ data }) => {
    return (
        <div className="flex justify-between items-center text-sm mb-2">
            <div className="text-gray-600">{data.label}</div>
            <div className="font-medium text-gray-800">{data.value}</div>
        </div>
    );
};

export default AccountSummaryStat;